import { responsiveHelper } from "./responsive-helper"
import authService from "./auth"
import store from "../../../store/index"
import Repository from "../../../repositories/Repository"
import router from "../../../router/index"
import { AUTH_URLS } from "./constants"
import { notification } from "ant-design-vue"

const REGISTER = "REGISTER"
const LOGIN = "LOGIN"

export default {
  props: {
    value: {},
  },
  data: function() {
    return {
      submitted: false,
      loading: false,
      unverified: false,
      success: true,
      requestSent: false,
      email: null,
      iconNO: `${process.env.SSO_STATIC_CONTENT_URL}/global/images/Error_Icon.svg`,
      isMobile: responsiveHelper.isMobileDevice(),
    }
  },
  methods: {
    submit: function(type) {
      console.log("login.js -> submit()")
      const self = this
      console.log("self:", self)
      self.submitted = true
      self.isFormValid().then(isValid => {
        if (isValid) {
          self.$emit("send")
          self.loading = true
          self.email = self.form.username
          let callback = type === REGISTER ? authService.methods.register : authService.methods.login
          let data =
            type === REGISTER ? { email: self.form.username, password1: self.form.password, password2: self.form.confirmPassword } : { email: self.form.username, password: self.form.password }
          return callback(data)
            .then(res => {
              if (type !== REGISTER) {
                self.requestSent = true
                const circleAuth = { dtoken: res.data.key, email: self.form.username }
                console.log("I am in login")
                store
                  .dispatch("Auth/ssoLogin", { circleAuth })
                  .then(res => {
                    // console.log("Place Three")  // WHILE LOGGING IN THROUGH MY CIRCLES
                    const user = store.state.User.user
                    if (user.user.token) {
                      Repository.defaults.headers.common["Authorization"] = `Bearer ${user.user.token}`
                    }
                    // self.form = self.setValues()
                    // self.$emit('close')
                    self.success = true
                    self.loading = false
                    setTimeout(() => {
                      self.form = self.setValues()
                      self.$emit("close")
                      location.reload()
                    }, 1000)
                    // this.$router.push({ path:'/searchpage' }).catch(err => {});
                  })
                  .catch(err => {
                    console.log(err.response, "login error")
                    // commit("User/setUser", { data: userData }, { root: true });
                    self.unverified = true
                    self.success = true
                    self.loading = false
                    self.$emit("close")
                    // location.reload()
                    // self.requestSent = false
                    // self.loading = false
                  })
              } else {
                self.loading = false
                if (res.data.email && res.data.email[0] === "user with this email address already exists.") {
                  self.emailAlreadyExists = true
                  return
                }
                self.emailAlreadyExists = false
                self.success = true
                setTimeout(() => {
                  self.form = self.setValues()
                  self.$emit("close")
                  // location.reload()
                }, 100)
                const payload = { username: self.form.username, password: self.form.password }
                console.log("I am in register and payload is,", payload)
                return authService.methods
                  .login(payload)
                  .then(res => {
                    console.log("I am in authservice login", self.form)
                    console.log("Response is", res)
                    const circleAuth = { dtoken: res.data.key, email: self.form.username, password: self.form.password }
                    store
                      .dispatch("Auth/ssoLogin", { circleAuth })
                      .then(res => {
                        // console.log("Place Four")
                        const user = store.state.User.user
                        if (user.user.token) {
                          Repository.defaults.headers.common["Authorization"] = `Bearer ${user.user.token}`
                        }
                        self.success = true
                        self.loading = false

                        setTimeout(() => {
                          self.form = self.setValues()
                          self.$emit("close")
                          location.reload()
                        }, 100)
                      })
                      .catch(err => {
                        self.unverified = true
                        self.success = true
                        self.loading = false
                        self.$emit("close")
                      })
                  })
                  .catch(e => console.log(e))
              }
            })
            .catch(err => {
              console.log(err)
              self.success = false
              self.loading = false
            })
        }
      })
    },
    tryAgain: function() {
      this.requestSent = false
    },
  },
  mounted() {
    this.form = this.setValues()
  },
}



// WEBPACK FOOTER //
// ./src/components/login/utils/login.js